module.exports = __webpack_public_path__ + "images/apple-touch-icon-57x57.2b4c357a6451c6683a1deba387260ba5.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/favicons/apple-touch-icon-57x57.png
// module id = 993
// module chunks = 0